var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductTileViewsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_12182_69833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9661 7.84073C16.9511 7.80072 16.5261 6.86055 15.5859 5.91537C14.3306 4.66513 12.7453 4 11 4C9.25467 4 7.66936 4.66513 6.41413 5.91537C5.47395 6.86055 5.04887 7.80072 5.03386 7.84073C5.01153 7.89113 5 7.94564 5 8.00076C5 8.05588 5.01153 8.1104 5.03386 8.16079C5.04887 8.2008 5.47395 9.14098 6.41413 10.0862C7.66936 11.3364 9.25467 12.0015 11 12.0015C12.7453 12.0015 14.3306 11.3364 15.5859 10.0862C16.5261 9.14098 16.9511 8.2008 16.9661 8.16079C16.9885 8.1104 17 8.05588 17 8.00076C17 7.94564 16.9885 7.89113 16.9661 7.84073ZM11 6.20042C11.3561 6.20042 11.7042 6.30601 12.0002 6.50383C12.2963 6.70166 12.527 6.98283 12.6633 7.3118C12.7996 7.64077 12.8352 8.00276 12.7658 8.35199C12.6963 8.70122 12.5248 9.02201 12.273 9.2738C12.0213 9.52558 11.7005 9.69705 11.3512 9.76651C11.002 9.83598 10.64 9.80033 10.311 9.66406C9.98207 9.5278 9.70089 9.29704 9.50307 9.00098C9.30524 8.70492 9.19966 8.35684 9.19966 8.00076C9.19966 7.52328 9.38934 7.06536 9.72696 6.72773C10.0646 6.3901 10.5225 6.20042 11 6.20042Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9661 7.84073C16.9511 7.80072 16.5261 6.86055 15.5859 5.91537C14.3306 4.66513 12.7453 4 11 4C9.25467 4 7.66936 4.66513 6.41413 5.91537C5.47395 6.86055 5.04887 7.80072 5.03386 7.84073C5.01153 7.89113 5 7.94564 5 8.00076C5 8.05588 5.01153 8.1104 5.03386 8.16079C5.04887 8.2008 5.47395 9.14098 6.41413 10.0862C7.66936 11.3364 9.25467 12.0015 11 12.0015C12.7453 12.0015 14.3306 11.3364 15.5859 10.0862C16.5261 9.14098 16.9511 8.2008 16.9661 8.16079C16.9885 8.1104 17 8.05588 17 8.00076C17 7.94564 16.9885 7.89113 16.9661 7.84073ZM11 6.20042C11.3561 6.20042 11.7042 6.30601 12.0002 6.50383C12.2963 6.70166 12.527 6.98283 12.6633 7.3118C12.7996 7.64077 12.8352 8.00276 12.7658 8.35199C12.6963 8.70122 12.5248 9.02201 12.273 9.2738C12.0213 9.52558 11.7005 9.69705 11.3512 9.76651C11.002 9.83598 10.64 9.80033 10.311 9.66406C9.98207 9.5278 9.70089 9.29704 9.50307 9.00098C9.30524 8.70492 9.19966 8.35684 9.19966 8.00076C9.19966 7.52328 9.38934 7.06536 9.72696 6.72773C10.0646 6.3901 10.5225 6.20042 11 6.20042Z",
    stroke: "black",
    strokeOpacity: 0.08,
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_12182_69833",
    x: 0.900391,
    y: 0.898438,
    width: 20.1992,
    height: 16.2031,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12182_69833"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12182_69833",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductTileViewsIcon);
export default __webpack_public_path__ + "static/media/product-tile-views-icon.4ddb5ea0e2631052d0abea7eea5381e5.svg";
export { ForwardRef as ReactComponent };